import { u, styled } from '../../../../shared/theming-sc'

const HeaderActionsBlock = styled.div`
    width: 50%;
    text-align: right;
    position: absolute;
    float: none;
    right: ${u.getSpacing('small')}px;

    ${u.media.greaterThan('lg')`
      position: relative;
      width: 60%;
      float: right;
      right: 0;
      right: ${u.getSpacing('large')}px;
    `};

    ${u.media.lessThan('sm')`
      position: relative;
      width: 100%;
      float: left
      right: 0;
      text-align: left;
    `};

`

const HeaderSearchButton = styled.a`
    color: ${u.getColor('grey')};
    font-size: ${u.getFontSize('md')};
    margin-right: 0px;
    cursor: pointer;

     ${u.media.greaterThan('lg')`
       display: none;
     `};

`

const HeaderActionButton = styled.a`
    color: ${u.getColor('grey')};
    font-size: ${u.getFontSize('md')};
    margin-right: 0px;
    position: relative;

    cursor: pointer;
    &:hover {
        color: ${u.getColor('grey')} !important;
    }

    ${u.media.greaterThan('lg')`
      margin-right: ${u.getSpacing('medium')}px;
     `};

`

// @devnote: Used by ../dymanicheader/DynamicHeaderButton
// Only differences to <HeaderActionButton> above: color, pointer, hover
const HeaderActionButtonDisabled = styled.a`
    color: ${u.getColor('greyLight')};
    font-size: ${u.getFontSize('md')};
    margin-right: 0px;
    position: relative;
    
    cursor: default;

    ${u.media.greaterThan('lg')`
      margin-right: ${u.getSpacing('medium')}px;
     `};
`

const HeaderActionIcon = styled.span`
    display: inline-block;
    position: relative;

    width: ${u.getSpacing('small')}px;
    height: ${u.getSpacing('small')}px;
    margin-right: ${u.getSpacing('small')}px;

    &:last-child {
        margin-right: 0;
    }

    ${u.media.greaterThan('lg')`
      border: 1px solid ${u.getColor('greyMuted')};
      border-radius: 100%;
      width: ${u.getSpacing('large')}px;
      height: ${u.getSpacing('large')}px;
      padding: 8px 0 0 9px;
    `};

`

const HeaderActionText = styled.span`
    position: relative;
    top: -15px;
    display: none

     ${u.media.greaterThan('lg')`
      display: inline;
     `};
`

const HintNumber = styled.span`
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: ${u.getColor('greyDark')};
    color: white;
    top: -12px;
    left: 12px;
    text-align: center;
    font-size: ${u.getFontSize('sm')}px;
    font-weight: 600;
    border-radius: 20px;
    z-index: 1;

    ${u.media.greaterThan('lg')`
         top: -30px;
         left: 30px;
    `}
`

export {HeaderActionsBlock, HeaderSearchButton, HeaderActionButton, HeaderActionIcon, HeaderActionText, HintNumber, HeaderActionButtonDisabled}
